import { render, staticRenderFns } from "./Navires.vue?vue&type=template&id=23132b3c&"
import script from "./Navires.vue?vue&type=script&lang=js&"
export * from "./Navires.vue?vue&type=script&lang=js&"
import style0 from "./Navires.vue?vue&type=style&index=0&id=23132b3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports